export const noSpacesValidatorRegExp = /^\S+$/;

const validateNoSpaces = (
  string: string,
): boolean => !string || noSpacesValidatorRegExp.test(string);

export default validateNoSpaces;
